import { ReactComponent as CrownSvg } from '../../../../assets/svg/crown.svg';
import { formatDate } from '../../../../lib/utils';

const ProgramCard = ({ userInfo }) => {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-500/30 to-slate-600/20 border border-slate-400/30 p-4 mt-2 group hover:shadow-lg transition-all duration-300`}
    >
      {/* Decorative elements */}
      <div className='absolute top-0 right-0 w-24 h-24 bg-slate-400/5 rounded-full -translate-y-1/2 translate-x-1/2'></div>
      <div className='absolute bottom-0 left-0 w-32 h-32 bg-slate-400/5 rounded-full translate-y-1/2 -translate-x-1/2'></div>

      {/* Content */}
      <div className='relative z-10'>
        <div className='flex items-center gap-2 mb-3 text-sm'>
          <div className='bg-slate-400/20 p-1 rounded-lg'>
            <CrownSvg className='size-3 text-slate-300' />
          </div>
          <div className='font-bold text-slate-300'>
            1 on 1 Coaching Program Member
          </div>
        </div>

        <div className='space-y-1 text-xs text-white'>
          <div className='flex items-center gap-2'>
            <div className='w-1.5 h-1.5 rounded-full bg-slate-400'></div>
            <span>
              Started on {formatDate(new Date(userInfo.programs[0]?.startDate))}{' '}
              (9 weeks)
            </span>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-1.5 h-1.5 rounded-full bg-slate-400'></div>
            <span>Unlimited access to AI meal tracker</span>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-1.5 h-1.5 rounded-full bg-slate-400'></div>
            <span>Direct feedback from coach</span>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-1.5 h-1.5 rounded-full bg-slate-400'></div>
            <span>Personal workout program and nutrition plan</span>
          </div>
          <div className='flex items-center gap-2'>
            <div className='w-1.5 h-1.5 rounded-full bg-slate-400'></div>
            <span>Priority support</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramCard;
